exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".load-vals[data-v-29daa30c] {\n  display: inline-block;\n  width: calc(33% - 10px);\n  margin-right: 10px;\n}\n.load-vals[data-v-29daa30c]::last-child {\n    margin-right: 0;\n}\n.load-vals span[data-v-29daa30c] {\n    font-size: smaller;\n    margin-left: -12px;\n}\n", ""]);

// exports
